import { render, staticRenderFns } from "./FundingSplitAllocation.vue?vue&type=template&id=fac69b10&"
import script from "./FundingSplitAllocation.vue?vue&type=script&lang=js&"
export * from "./FundingSplitAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports